import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Check } from 'assets/icons/check.svg';

const ActionPanel = ({
  testId,
  actionText,
  text,
  text2,
  onClick,
  Icon,
  className,
}) => {
  return (
    <div
      data-testid={testId}
      className={`${className} p-4 flex flex-col md:flex-row justify-between w-full rounded mb-5 items-center`}
    >
      <div className="flex items-center w-full">
        {Icon}
        <div className="flex flex-col w-full px-4">
          <span className="text-sm font-semibold">{text}</span>
          {!!text2 && <span className="text-sm">{text2}</span>}
        </div>
      </div>
      <p
        data-testid="dismiss"
        className="text-sm underline text-right cursor-pointer min-w-max"
        onClick={onClick}
      >
        {actionText}
      </p>
    </div>
  );
};

ActionPanel.propTypes = {
  testId: PropTypes.string,
  Icon: PropTypes.node,
  onClick: PropTypes.func,
  actionText: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
};
ActionPanel.defaultProps = {
  testId: 'action-panel',
  Icon: <Check className="fill-current w-6 h-6 mr-3 mt-0.5 md:mt-0" />,
  className: 'bg-brand-primary text-white',
};

export default memo(ActionPanel);
